import type { ReactNode } from 'react';

import { TooltipProvider } from '@/components/ui/tooltip';

interface DashboardWorkspaceBarProps {
    leading?: ReactNode;
    menu: ReactNode;
    status: ReactNode;
    modes?: ReactNode;
}

export function DashboardWorkspaceBar({
    leading,
    menu,
    status,
    modes
}: DashboardWorkspaceBarProps) {
    return (
        <div className="flex justify-between items-center gap-2 px-4 py-2 border-b border-border">
            <div className="flex items-center gap-2 min-w-0">
                {leading}
                {menu}
            </div>
            <TooltipProvider>
                <div className="flex items-center gap-1">
                    {status}
                    {modes}
                </div>
            </TooltipProvider>
        </div>
    );
}
